import { Button } from '@material-ui/core';
import classNames from 'classnames';
import style from './rbButton.style';

function RBButton({ cbHandleClick, disabled = false, btnName, id, type, ...rest }) {
	const classes = style();
	const { root, primaryBtn, secondryBtn } = classes;
	const customClass = classNames({
		[root]: true,
		[primaryBtn]: type === 'primary',
		[secondryBtn]: type === 'secondary'
	});

	return (
		<Button
			id={id}
			disabled={disabled}
			onClick={(e) => {
				e.stopPropagation();
				cbHandleClick(e);
			}}
			className={customClass}
			{...rest}>
			{btnName}
		</Button>
	);
}

export default RBButton;
